import axios from "axios";
import moment from "moment";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";
const REACT_APP_X_API_KEY = process.env.REACT_APP_X_API_KEY || "";

const isDevelopment =
  API_BASE_URL === "" ||
  API_BASE_URL === "https://sit-api-crm.getzpay.com" ||
  API_BASE_URL === "https://sit-applepay.getzpay.com" ||
  API_BASE_URL === "https://staging-api.getzpay.com" ||
  API_BASE_URL.includes("local");

export const dashboardApi = {
  getDashboardData: async (
    token: string,
    brandId: string,
    segment?: string,
    segmentId?: number,
    fromDate?: Date | string,
    toDate?: Date | string,
    period?: string,
    filterPDPA?: number | null,
    filterBrand?: string[] | null,
    filterStore?: string[] | null,
    filterPurchaseBrand?: string[] | null,
    filterPurchaseStore?: string[] | null,
    segmentsIds?: number[] | null,
    filterRecency?: number[] | null,
    filterFrequency?: number[] | null,
    filterMonetary?: number[] | null,
    filterCampaign?: number | null,
  ) => {
    const requestBody: any = {
      BrandId: brandId,
      FromDate:
        fromDate === "Lifetime"
          ? "Lifetime"
          : moment(fromDate).format("YYYY-MM-DD"),
      ToDate: toDate
        ? moment(toDate)
            .set({ hour: 23, minute: 59, second: 59 })
            .format("YYYY-MM-DD HH:mm:ss")
        : moment()
            .subtract(1, "day")
            .set({ hour: 23, minute: 59, second: 59 })
            .format("YYYY-MM-DD HH:mm:ss"),
      Period: period,
      FilterPDPA: filterPDPA,
      FilterBrand: filterBrand,
      FilterStore: filterStore,
      FilterPurchaseBrand: filterPurchaseBrand,
      FilterPurchaseStore: filterPurchaseStore,
      SegmentIds: segmentsIds,
      FilterRecency: filterRecency,
      FilterFrequency: filterFrequency,
      FilterMonetary: filterMonetary,
      FilterCampaign: filterCampaign,
    };
    if (segment) requestBody.Segment = segment;
    if (segmentId !== undefined && segmentId !== null)
      requestBody.SegmentId = segmentId;
    const endpoint = isDevelopment
      ? `${API_BASE_URL}/v1/RFM/Dashboard`
      : `${API_BASE_URL}/v1/RFM/GetMemberRedshift`;
    return axios.post(endpoint, requestBody, {
      headers: {
        Authorization: `Basic ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
  getMember: async (
    token: string,
    brandId: string,
    segment?: string,
    segmentId?: number,
    fromDate?: Date | string,
    toDate?: Date | string,
    period?: string,
    filterPDPA?: number | null,
    filterBrand?: string[] | null,
    filterStore?: string[] | null,
    filterPurchaseBrand?: string[] | null,
    filterPurchaseStore?: string[] | null,
    includeVoucher?: boolean,
    includePoint?: boolean,
    segmentsIds?: number[] | null,
    filterRecency?: number[] | null,
    filterFrequency?: number[] | null,
    filterMonetary?: number[] | null,
    filterCampaign?: number | null,
  ) => {
    const requestBody: any = {
      BrandId: brandId,
      FromDate:
        fromDate === "Lifetime"
          ? "Lifetime"
          : moment(fromDate).format("YYYY-MM-DD"),
      ToDate: toDate
        ? moment(toDate)
            .set({ hour: 23, minute: 59, second: 59 })
            .format("YYYY-MM-DD HH:mm:ss")
        : moment()
            .subtract(1, "day")
            .set({ hour: 23, minute: 59, second: 59 })
            .format("YYYY-MM-DD HH:mm:ss"),
      Period: period,
      FilterPDPA: filterPDPA,
      FilterBrand: filterBrand,
      FilterStore: filterStore,
      FilterPurchaseBrand: filterPurchaseBrand,
      FilterPurchaseStore: filterPurchaseStore,
      IncludeVoucher: includeVoucher ?? false,
      IncludePoint: includePoint ?? false,
      SegmentIds: segmentsIds,
      FilterRecency: filterRecency,
      FilterFrequency: filterFrequency,
      FilterMonetary: filterMonetary,
      FilterCampaign: filterCampaign,
      // TESTING PURPOSE
      //IncludeUser: true,
    };
    if (segment) requestBody.Segment = segment;
    if (segmentId !== undefined && segmentId !== null)
      requestBody.SegmentId = segmentId;
    const endpoint = isDevelopment
      ? `${API_BASE_URL}/v1/RFM/DownloadMember`
      : `${API_BASE_URL}/v1/RFM/DownloadMemberRedshift`;
    return axios.post(endpoint, requestBody, {
      responseType: "blob",
      headers: {
        Authorization: `Basic ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
  cleanBrandCache: async (token: string, brandId: string) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/CleanAllBrandCache?brandId=${brandId}&cleanAll=true`,
      {},
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
          "X-API-KEY": REACT_APP_X_API_KEY,
        },
      },
    );
  },
  getOldestMemberSignup: async (token: string, brandId: string) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/GetOldestMemberSignup`,
      { BrandId: brandId },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
  },
};
